module.exports = "/_next/static/images/23894c3e1006f6130f9901577ee32cc2-slide-2.png.webp";